import { createPhaseAction } from 'src/helpers/redux'
import {
  IAssigneNumberParams,
  IAssigneRcNumber,
  IGetAvailableNumbersParams,
  IDeleteAccount,
} from 'src/services/numbers'
import type * as accountsType from 'src/services/accounts'

export const PREFIX = 'numbers'
export const SAGA = `${PREFIX}/saga`

export const actions = {
  getAvailableNumbersTwillio: createPhaseAction<IGetAvailableNumbersParams>(
    `${SAGA}/getAvailableNumbers`
  ),
  getAvailableNumbersRc: createPhaseAction<void>(
    `${SAGA}/getAvailableNumbersRc`
  ),
  assigneTwillioNumber: createPhaseAction<IAssigneNumberParams>(
    `${SAGA}/assigneNumber`
  ),
  assigneRcNumber: createPhaseAction<IAssigneRcNumber>(
    `${SAGA}/assigneRcNumber`
  ),
  getNumbers: createPhaseAction<accountsType.IGetAccounts>(
    `${SAGA}/getNumbers`
  ),

  getAccount: createPhaseAction<accountsType.IGetAccountParams>(
    `${SAGA}/getAccount`
  ),
  postAccountsUpdate: createPhaseAction<accountsType.IPostAccountsUpdateParams>(
    `${SAGA}/postAccountsUpdate`
  ),
  deleteAccounts: createPhaseAction<accountsType.IDeleteAccountParams>(
    `${SAGA}/deleteAccounts`
  ),

  fetchMore: createPhaseAction<accountsType.IGetAccounts>(`${SAGA}/fetchMore`),
  releaseNumber: createPhaseAction<IDeleteAccount>(`${SAGA}/releaseNumber`),
}
export type Actions = typeof actions
